import React from "react";
import { ROUTES } from "../../data/routes";

const NavLinks = () => {
  return (
    <ul className="nav-links flex items-center justify-end">
      {ROUTES.map((route, index) => {
        const { name, to } = route;

        return (
          <li key={index}>
            <a href={to} className="text-primary">
              {name}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default NavLinks;
